import { handle } from 'redux-pack';
import messages from './messages';

export const handleSaveVideoLink = (state, action) =>
  ({
    ...state,
    videoUrl: action.extraProperties.url,
  });

export const uploadVideoPromise = (payload) => ({
  failure: (prevState) => ({
    ...prevState,
    hasSnackbar: true,
    snackbarState: 'error',
    snackbarMessage: messages.failureUpdateVideo.defaultMessage,
  }),
  success: (prevState) => ({
    ...prevState,
    videoUrl: payload.sourceId,
    videoId: payload.id,
    hasSnackbar: true,
    snackbarState: 'success',
    snackbarMessage: messages.successUpdateVideo.defaultMessage,
  }),
});

export const handleUploadVideo = (state, action) =>
  handle(state, action, uploadVideoPromise(action.payload));

export const handleUpdateHasSnackbar = (state, action) =>
  ({
    ...state,
    hasSnackbar: action.extraProperties.state,
  });

export const deleteVideoLinkPromise = () => ({
  failure: (prevState) => ({
    ...prevState,
    hasSnackbar: true,
    snackbarState: 'error',
    snackbarMessage: messages.failureDeleteVideoLink.defaultMessage,
  }),
  success: (prevState) => ({
    ...prevState,
    videoUrl: '',
    videoId: '',
    hasSnackbar: true,
    snackbarState: 'success',
    snackbarMessage: messages.successDeleteVideoLink.defaultMessage,
  }),
});

export const handleDeleteVideoLink = (state, action) =>
  handle(state, action, deleteVideoLinkPromise());

export const fetchVideoLinkPromise = (payload) => ({
  failure: (prevState) => ({
    ...prevState,
    hasSnackbar: true,
    snackbarState: 'error',
    snackbarMessage: messages.failureFetchVideoLink.defaultMessage,
  }),
  success: (prevState) => ({
    ...prevState,
    videoUrl: (payload && payload[0] && payload[0].url) || '',
    videoId: (payload && payload[0] && payload[0].id) || '',
  }),
});

export const handleFetchVideoLink = (state, action) =>
  handle(state, action, fetchVideoLinkPromise(action.payload));
